import { solar_module_technology_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateSolarModuleTechnologyEnum = (enumValue: solar_module_technology_enum) => {
  switch (enumValue) {
    case solar_module_technology_enum.POLY_CRYSTALLINE:
      return <Trans i18nKey="Enum_SolarModuleTechnologyEnum-POLY_CRYSTALLINE" />;
    case solar_module_technology_enum.HIGH_EFFICIENCY_MODULES:
      return <Trans i18nKey="Enum_SolarModuleTechnologyEnum-HIGH_EFFICIENCY_MODULES" />;
    case solar_module_technology_enum.MONO_CRYSTALLINE:
      return <Trans i18nKey="Enum_SolarModuleTechnologyEnum-MONO_CRYSTALLINE" />;
    case solar_module_technology_enum.CIS_CIGS:
      return <Trans i18nKey="Enum_SolarModuleTechnologyEnum-CIS_CIGS" />;
  }
};

export const translateSolarModuleTechnologyEnum_dynamic = (enumValue: solar_module_technology_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case solar_module_technology_enum.POLY_CRYSTALLINE:
      return t('Enum_SolarModuleTechnologyEnum-POLY_CRYSTALLINE');
    case solar_module_technology_enum.HIGH_EFFICIENCY_MODULES:
      return t('Enum_SolarModuleTechnologyEnum-HIGH_EFFICIENCY_MODULES');
    case solar_module_technology_enum.MONO_CRYSTALLINE:
      return t('Enum_SolarModuleTechnologyEnum-MONO_CRYSTALLINE');
    case solar_module_technology_enum.CIS_CIGS:
      return t('Enum_SolarModuleTechnologyEnum-CIS_CIGS');
  }
};
